// extracted by mini-css-extract-plugin
module.exports = {"dashboardContainer":"dashboard_dashboardContainer__21Tnw","labsTable":"dashboard_labsTable__1zcoo"};